import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-max-diff",
  "use": "foquz-icon-question-max-diff-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-max-diff\"><path d=\"M9.75 11.375h6.5m-6.5 4.875h6.5M13 21.125h3.25M9.75 6.5H13m8.125 17.875V3.25m-3.25 3.25l3.25-3.25 3.25 3.25m-19.5-1.625v19.5m-3.25-3.25l3.25 3.25 3.25-3.25\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol